export const getQueryStatus = (status) => {
    const isConnected = status === 'pending';
    const isConnection = status === 'loading';
    return {
        isConnection,
        isConnected,
    };
};
